<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ languageLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex>
            <v-text-field
              label="Name"
              v-model="l.name"
              @input="$v.l.name.$touch()"
              @blur="$v.l.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              label="Code"
              v-model="l.code"
              @input="$v.l.code.$touch()"
              @blur="$v.l.code.$touch()"
              :error-messages="codeErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col>
            <v-checkbox
              label="For Content"
              v-model="l.forContent"
              primary
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              label="Is Default"
              v-model="l.isDefault"
              primary
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  LANGUAGE_UPDATE_MUTATION,
  LANGUAGE_CREATE_MUTATION,
} from "../../../../constants/graphql";
import { required } from "vuelidate/lib/validators";

export default {
  name: "LanguageEditor",

  props: {
    language: {
      type: Object,
      default: () => ({}),
    },

    doSaveLanguage: {
      type: Boolean,
      default: false,
    },

    languageEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      l: { ...this.language },
      debug: false,
    };
  },

  methods: {
    saveLanguage() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? LANGUAGE_UPDATE_MUTATION
            : LANGUAGE_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.l,
            },
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    languageLabel() {
      return this.language.id != null ? this.language.name : "New Language";
    },
    context() {
      return this.language.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.l.name.$dirty) {
        return errors;
      }
      if (!this.$v.l.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    codeErrors() {
      let errors = [];
      if (!this.$v.l.code.$dirty) {
        return errors;
      }
      if (!this.$v.l.code.required) {
        errors.push("Code is required.");
      }
      return errors;
    },
  },

  watch: {
    language(data) {
      let language = { ...data };
      delete language.__typename;
      this.l = language;
    },
    languageEditorDialog(value) {
      if (!value) {
        this.l = {};
        this.$v.$reset();
      }
    },
    doSaveLanguage(value) {
      if (value) {
        this.saveLanguage();
      }
    },
  },
  validations: {
    l: {
      name: { required },
      code: { required },
    },
  },
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/gt/admin/languages/LanguageEditor.vue